<template>
  <v-dialog v-model="dialog" max-width="720" persistent>
    <v-card>

      <!-- Header -->
      <v-card-title class="d-flex align-center gap-2 px-5 pt-4 pb-0">
        <v-avatar color="orange darken-2" size="36">
          <v-icon color="white" size="20">mdi-clock-outline</v-icon>
        </v-avatar>
        <div>
          <div class="text-h6 font-weight-bold ml-2"> Comprobantes pendientes </div>
          <div class="text-body-2 ml-2 mb-0">
            Solicitudes de pre inscripcion realizadas por asesores.
          </div>
        </div>
        <!-- <span class="text-subtitle-1 font-weight-bold ml-2">Comprobantes pendientes</span> -->
        <v-spacer />
        <v-btn icon small @click="cerrar">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider />
      <timelineProgreso ref="reftimelineProgreso"/>
      <v-divider class="mt-0" />

      <!-- Filtros -->
      <div class="px-5 py-3 bannercito">
        <v-row dense>
          <v-col cols="12" sm="4">
            <v-select
              v-model="filtros.estado"
              :items="opcionesEstado"
              label="Estado"
              dense
              outlined
              hide-details
            />
          </v-col>
          <v-col cols="6" sm="4">
            <v-text-field
              v-model="filtros.desde"
              label="Desde"
              type="date"
              dense
              outlined
              hide-details
            />
          </v-col>
          <v-col cols="6" sm="4">
            <v-text-field
              v-model="filtros.hasta"
              label="Hasta"
              type="date"
              dense
              outlined
              hide-details
            />
          </v-col>
        </v-row>
        <div class="d-flex justify-end mt-2">
          <v-btn small depressed color="orange darken-2" dark :loading="loading" @click="buscar">
            <v-icon left small>mdi-magnify</v-icon>
            Buscar
          </v-btn>
        </div>
      </div>

      <v-divider />

      <v-card-text class="pa-0">

        <!-- Loading -->
        <div v-if="loading" class="d-flex justify-center align-center py-10">
          <v-progress-circular indeterminate color="orange darken-2" />
        </div>

        <!-- Sin resultados -->
        <div v-else-if="!pendientes.length" class="d-flex flex-column align-center justify-center py-10 text--secondary">
          <v-icon size="48" color="grey lighten-1">mdi-check-circle-outline</v-icon>
          <span class="mt-2 text-body-2">Sin comprobantes</span>
        </div>

        <!-- Lista -->
        <v-list v-else two-line class="py-0 lista-pendientes">
          <v-list-item v-for="item in pendientes" :key="item.id" class="px-5 py-2">
            <v-list-item-avatar color="orange lighten-4" size="40">
              <v-icon color="orange darken-2" size="20">mdi-bank-outline</v-icon>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title class="text-body-2 font-weight-medium">
                {{ item.nombre_depositante }}
              </v-list-item-title>
              <v-list-item-subtitle class="text-caption">
                {{ item.banco }} · Cta: {{ item.nro_cuenta }} · Comprobante: {{ item.nro_comprobante }}
              </v-list-item-subtitle>
              <v-list-item-subtitle class="text-caption mt-1">
                Registrado por {{ item.created_by }}
              </v-list-item-subtitle>
              <v-list-item-subtitle class="text-caption mt-1">
                {{ item.fecha_pago | fecha }}
              </v-list-item-subtitle>
              <p>
                {{ item.observaciones_rechazo }}
              </p>
            </v-list-item-content>

            <v-list-item-action class="flex-column align-end" style="min-width:100px;">
              <span class="text-body-2 font-weight-bold orange--text text--darken-2">
                Bs {{ item.monto }}
              </span>
              <v-chip x-small :color="colorEstado(item.estado_comprobante).bg" :text-color="colorEstado(item.estado_comprobante).text" class="mt-1">
                {{ item.estado_comprobante }}
              </v-chip> 
              <v-btn small color="blue darken-2" dark depressed class="mt-2" @click="openGenerarRecibo(item)" v-if="filtros.estado=='PENDIENTE'">
                <v-icon left x-small>mdi-receipt</v-icon>
                Generar recibo
              </v-btn>
            </v-list-item-action> 
          </v-list-item>
        </v-list>

      </v-card-text>

      <v-divider />

      <v-card-actions class="px-5 py-3">
        <span class="text-caption text--secondary">
          {{ pendientes.length }} registro{{ pendientes.length !== 1 ? 's' : '' }}
          <span v-if="totalPaginas > 1"> · Pág {{ filtros.page }} / {{ totalPaginas }}</span>
        </span>
        <v-spacer />
        <v-btn icon x-small :disabled="filtros.page <= 1 || loading" @click="cambiarPagina(-1)">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-btn icon x-small :disabled="filtros.page >= totalPaginas || loading" @click="cambiarPagina(1)">
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
        <v-btn text small @click="cerrar" class="ml-2">Cerrar</v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
import xaxios from '@/xaxios'
import timelineProgreso from './timeline-progreso.vue';

function hoy() {
  return new Date().toISOString().substring(0, 10)
}
function hace30dias() {
  const d = new Date()
  d.setDate(d.getDate() - 31)
  return d.toISOString().substring(0, 10)
}

export default {
  components:{ timelineProgreso },
  filters: {
    fecha(val) {
      if (!val) return ''
      return val.substring(0, 16).replace('T', ' ')
    },
  },
  data() {
    return {
      loading: false,
      dialog: false,
      pendientes: [],
      total: 0,
      opcionesEstado: ['PENDIENTE', 'APROBADO', 'RECHAZADO'],
      filtros: {
        estado: 'PENDIENTE',
        desde: hace30dias(),
        hasta: hoy(),
        page: 1,
        per_page: 30,
        sede_id: -1,
      },
    }
  },
  watch:{
    'filtros.estado'(){
      this.listar_pendientes()
    },
    '$store.state.CARGO.sede'(){
      this.listar_pendientes()
    }
  },
  computed: {
    totalPaginas() {
      return Math.ceil(this.total / this.filtros.per_page) || 1
    },
  },
  methods: {
    async openmodal() {
      this.dialog = true;
      // this.filtros.estado = 'PENDIENTE'
      this.$nextTick(() => {
        this.$refs.reftimelineProgreso.iniciar(3, false); 
      }); 
      void this.listar_pendientes();
    },
    cerrar() {
      this.dialog = false;
      this.filtros.estado = 'PENDIENTE'
    },
    buscar() {
      this.filtros.page = 1;
      this.listar_pendientes();
    },
    cambiarPagina(delta) {
      this.filtros.page += delta;
      this.listar_pendientes();
    },
    colorEstado(estado) {
      const map = {
        PENDIENTE:  { bg: 'orange lighten-4', text: 'orange darken-3' },
        APROBADO:   { bg: 'green lighten-4',  text: 'green darken-3'  },
        RECHAZADO:  { bg: 'red lighten-4',    text: 'red darken-3'    },
      }
      return map[estado] || { bg: 'grey lighten-3', text: 'grey darken-2' }
    },
    async listar_pendientes() {
      this.loading = true
      this.pendientes = []
      this.filtros.sede_id = this.$store.state.CARGO.sede.id;
      
      const { estado, desde, hasta, page, per_page, sede_id } = this.filtros;
      const url = `${process.env.VUE_APP_API_REST}/api/esam/comprobante-pago?estado=${estado}&desde=${desde}&hasta=${hasta}T23:59:59Z&page=${page}&per_page=${per_page}&sede_id=${sede_id}`;
      const r = await xaxios.get(url).then(({ data }) => data).catch(e => e)
      this.loading = false;
      let cantidad = 0;
      if (r && r.data) {
        const dts = r.data.data || [];
        this.pendientes = dts.reverse();
        // this.pendientes = dts;
        this.total = r.data.total || this.pendientes.length;
        cantidad = this.total;
      }
      this.$emit('oncantidad', cantidad)
    },
    openGenerarRecibo(p) {
      this.$emit('openGenRecibo', p)
      setTimeout(() => {
        this.cerrar()
      }, 4000);
    }
  },
  mounted() {
    this.listar_pendientes()
  }
};
</script>

<style scoped>
.lista-pendientes .v-list-item:not(:last-child) {
  border-bottom: 1px solid rgba(0,0,0,0.08);
}
.bannercito {
  background: #f2eee5;
}
</style>
